import { faSackDollar, faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons';
import { faPanelEws } from '@fortawesome/pro-solid-svg-icons';

import { Step } from 'src/common/components/steps/steps.types';

export const stepsData: Step[] = [
  {
    stepNumber: 'Step 1',
    icon: faSackDollar,
    title: 'Purchase',
    description: 'Select the amount and length of subscription of your voucher.',
  },
  {
    stepNumber: 'Step 2',
    icon: faPanelEws,
    title: 'View in Dashboard',
    description: 'View your voucher codes and their status on your dashboard.',
  },
  {
    stepNumber: 'Step 3',
    icon: faHandHoldingHeart,
    title: 'Allocate',
    description: 'Allocate the vouchers and have your students redeem them.',
  },
];
